import { Component, OnInit, Input } from '@angular/core';
import { ProductsService } from 'src/app/products.service';

@Component({
  selector: 'app-nested-nav-relatedproducts',
  templateUrl: './nested-nav-relatedproducts.component.html',
  styleUrls: ['./nested-nav-relatedproducts.component.scss']
})
export class NestedNavRelatedproductsComponent implements OnInit {
  cardDisplay = [];

  @Input("data") productTitles: any[];
  carousel = [];

  constructor(
    public _productsService: ProductsService
    ) {
    }

  ngOnInit() {
    // Create a Map for O(1) lookup time
    const productMap = new Map(
      this._productsService.productcards.map(card => [card.title, card])
    );

    // Use the Map to efficiently find matching products
    this.cardDisplay = this.productTitles
      .map(title => productMap.get(title))
      .filter((card) => card !== undefined);
    while (this.cardDisplay.length > 0){
      this.carousel.push(this.cardDisplay.splice(0, 4));
    }
  }
  

}
